<template>
  <div class="detail_box">
    <!-- 标题 -->
    <div class="title" v-text="detailInfo.title"></div>
    <!-- 媒体号 -->
    <div class="we-media" v-if="detailInfo.selfChannelOrNot">
      <div class="portrait">
        <img :src="lconImagePath" @click="toMedia(detailInfo.reporterFreJSON.id)" />
      </div>
      <div class="text">
        <div class="nick" v-text="name" @click="toMedia(detailInfo.reporterFreJSON.id)"></div>
        <div class="created">
          <span v-text="publishTime"></span>
          <span class="readnum" v-if="detailInfo.isShowPlayCount">阅读量：<span v-text="detailInfo.playCount"></span></span>
        </div>
        <span class="attention" @click="onAttentionClick($event)" v-text="attentionStr">+ 关注</span>
      </div>
    </div>
    <!-- 非媒体号 -->
    <div class="junior clearfix" v-else>
      <span class="source" v-text="detailInfo.source"></span>
      <span class="time" v-text="publishTime"></span>
      <span class="readnum" v-if="detailInfo.isShowPlayCount">阅读量：<span v-text="detailInfo.playCount"></span></span>
    </div>
    <!-- 详情内容 -->
    <div class="content" v-html="detailInfo.text" @click="showImg($event)"></div>
    <div style="display: flex;">
      <!-- 责任编辑 -->
      <div class="editor" v-if="!!detailInfo.editor" v-text="'责任编辑：' + detailInfo.editor"></div>
      <!-- 审核 -->
      <div class="editor" style="padding-left: 5px;" v-if="!!detailInfo.editorDirector" v-text="'审核：' + detailInfo.editorDirector"></div>
    </div>
    <div class="line"></div>
    <div class="moreNews" v-if="detailInfo.isOriginal==1 || detailInfo.isOriginal==true">
      <p>更多精彩报道，请下载 <a href="https://jms.ctdsb.net/web/download.html" target="_blank">极目新闻</a></p>
      <p class="others" v-if="detailInfo.source&&detailInfo.source.length>0&&detailInfo.source.includes('极目新闻')">原创作品，未经授权不得转载。点击查看<span class="to_copyright" @click="toCopyright"> 版权声明</span>。</p>
      <p class="others" v-else>本文为极目号作者或合作机构在极目新闻发布内容，仅代表该作者或机构观点，不代表极目新闻的观点或立场。</p>
      <p class="others">报料渠道：拨打24小时新闻热线027-86777777；登录极目新闻“报料”；私信“楚天都市报极目新闻”新浪微博，或关注“楚天都市报极目新闻”官方微信私信报料。</p>
    </div>
    <div class="line" v-if="detailInfo.isOriginal==1 || detailInfo.isOriginal==true"></div>
    <div class="related_box" v-if="detailInfo.contentType==5 && detailInfo.specialList && detailInfo.specialList.length>0">
      <div class="related_special">
        <div class="labelbar"><i></i>相 关 专 题<i></i></div>
      </div>
      <ul class="news_list">
        <li v-for="item in detailInfo.specialList" :key="item.id">
          <div class="news_item" @click="toSpecial(item)">
            <div class="news_title" v-text="item.title"></div>
          </div>
        </li>
      </ul>
    </div>
    <!-- 标签 -->
    <div class="tag_list" v-if="tagList.length > 0">
      <ul class="clearfix">
        <li v-for="item in tagList" :key="item.id" v-text="'# ' + item"></li>
      </ul>
    </div>
    <!-- 点赞 -->
    <div class="praise_box" v-if="detailInfo.allowLikes != false && detailInfo.allowLikes != 0">
      <div class="praise" @click="onPraiseClick($event)" ref="praise1">
        <Icon iconClass="candle" v-if="detail.likeType=='10' && isLiked==false" />
        <Icon iconClass="candle-on" v-else-if="detail.likeType=='10' && isLiked==true" />
        <Icon iconClass="pray" v-else-if="detail.likeType=='11' && isLiked==false" />
        <Icon iconClass="pray-on" v-else-if="detail.likeType=='11' && isLiked==true" />
        <van-icon name="like-o" v-else-if="isLiked==false" />
        <van-icon name="like" v-else-if="isLiked==true" />
        <span v-text="topCount"></span>
      </div>
    </div>
    <div class="media_reporter_box">
      <!-- 记者号列表 -->
      <div class="news_media_list" v-if="!!reporterMediaList && reporterMediaList.length>1">
        <div class="news_media_title"><span>对这篇文章有想法？跟我聊聊吧</span></div>
        <ul>
          <li class="media_item" v-for="item in reporterMediaList" :key="item.id">
            <div class="portrait" :style="{backgroundImage:'url(' +(item.lconImagePath == ''? require('@/assets/images/user_default.png'): item.lconImagePath) +')'}" @click="toMedia(item.id)"></div>
            <div class="name" @click="toMedia(item.id)">{{item.name}}</div>
          </li>
        </ul>
      </div>
      <div class="news_media" v-else-if="!!reporterMedia && JSON.stringify(reporterMedia) != '{}'">
        <div class="media_reporter" @click="toMedia(reporterMedia.id)">
          <div class="reporter_portrait">
            <img :src="reporterMedia.lconImagePath == '' ? require('@/assets/images/user_default.png') : reporterMedia.lconImagePath" />
          </div>
          <div class="reporter_info">
            <div class="reporter_name">
              <span class="name" v-text="reporterMedia.name"></span>
              <span class="sub_num">关注数：<span v-text="reporterMedia.subscribeNum"></span></span>
            </div>
            <div class="reporter_intr" v-text="reporterMedia.introduce"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import jq from "jquery";
import { ImagePreview } from 'vant';
import { mapState } from "vuex";
import { deepClone, addScore } from "@/utils";
import commApi from "@/api/apis/common.js";
import mediaApi from "@/api/apis/media.js";
export default {
  name: "Detail",
  props: {
    params: {
      type: Object,
      default: null,
    },
    detail: {
      type: Object,
      default: null,
    },
    deviceId: {
      type: String,
      default: null,
    },
    reporterMedia: {
      type: Object,
      default: null,
    },
    reporterMediaList: {
      type: Array,
      default: [],
    },
    isPraise:{}
  },
  data() {
    return {
      headerHidden: false, // 是否隐藏顶部
      detailInfo: null,
      attentionStr: "+ 关注",
      topCount: 0, //点赞数
      isLiked: false,
    };
  },
  computed: {
    ...mapState("app", ["userInfo", "nodeCode"]),
    /* 发布时间 */
    publishTime() {
      if (!!this.detailInfo.firstAppPublishTime && this.detailInfo.firstAppPublishTime.length > 0) {
        return this.detailInfo.firstAppPublishTime.slice(0, 16);
      } else if (!!this.detailInfo.publishTime && this.detailInfo.publishTime.length > 0) {
        return this.detailInfo.publishTime.slice(0, 16);
      }
    },
    /* 媒体号头像 */
    lconImagePath() {
      let channelJson = this.detailInfo.channelJson;
      if (channelJson) {
        return channelJson.lconImagePath;
      }
    },
    /* 媒体号名称 */
    name() {
      let channelJson = this.detailInfo.channelJson;
      if (channelJson) {
        return channelJson.name;
      }
    },
    /* 标签 */
    tagList() {
      let tagList = this.detailInfo.tags;
      if (tagList) {
        return tagList.split(/,|，|\s+/);
      } else {
        return [];
      }
    },
  },
  watch: {
    detail: {
      handler(newValue, oldValue) {
        this.detailInfo = deepClone(newValue);
        if (!!this.detailInfo) {
          this.getThumbsUpStatus();
        }
      },
      deep: true,
    },
    isPraise: {
      handler(newValue, oldValue) {
        
        if (newValue!=oldValue) {
          this.getThumbsUpStatus();
        }
      },
    },
  },
  methods: {
    showImg(e) {
      if (e.target.tagName == 'IMG') {
        ImagePreview({
          // data-path正常情况下等于src，针对长图，设置data-path为原图，src为压缩图
          images: [e.target.getAttribute("data-path") || e.target.src],
          maxZoom: 10
        });
      }
    },
    /* 跳转版权声明 */
    toCopyright() {
      if (!!this.headerHidden) {
        this.$router.push({
          path: "/copyright",
          query: {
            client: 1
          },
        });
      } else {
        this.$router.push("/copyright");
      }
    },
    /* 增加积分 */
    addScore(code) {
      let jf_params = {};
      if (code == "dy") {
        jf_params = {
          code: 'dy', // 必传 (xsgg、fxcg、lnr、tpdcfbcg、gksp、zbj、dy、dz、sc)
          description: "订阅", // 必传，积分类型描述 (欣赏广告、分享内容、浏览内容、参与投票、观看视频、直播间、订阅、点赞、收藏)
          // contentType: this.mediaParams.contentType, // 非必传，稿件的type
          // contentId: this.detailInfo.selfChannelId, // 非必传，稿件的id
          // contentName: this.detailInfo.selfChannelName, // 非必传，稿件的标题
        }
      } else if (code == "dz") {
        jf_params = {
          code: 'dz', // 必传 (xsgg、fxcg、lnr、tpdcfbcg、gksp、zbj、dy、dz、sc)
          description: "点赞", // 必传，积分类型描述 (欣赏广告、分享内容、浏览内容、参与投票、观看视频、直播间、订阅、点赞、收藏)
          contentType: this.params.contentType, // 非必传，稿件的type
          contentId: this.params.contentId, // 非必传，稿件的id
          contentName: this.detailInfo.title, // 非必传，稿件的标题
        }
      }
      if (!!this.userInfo) {
        jf_params = Object.assign(jf_params, {
          memberId: this.userInfo.id, //会员id
        });
      }
      addScore(jf_params);
    },
    /* 获取订阅信息 */
    getSubscription() {
      var _this = this;
      var params = {
        id: _this.detailInfo.selfChannelId,
        userId: _this.userInfo.id,
        nodeCode: _this.nodeCode,
      };
      mediaApi
        .isSubscribe(params)
        .then((res) => {
          if (res.suc == 1) {
            _this.subscribed = true;
            _this.attentionStr = "已关注";
          } else {
            _this.subscribed = false;
            _this.attentionStr = "+ 关注";
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 关注 */
    subscribeSelfMedia() {
      var _this = this;
      var params = {
        id: _this.detailInfo.selfChannelId,
        userId: _this.userInfo.id,
        nodeCode: _this.nodeCode,
      };
      mediaApi
        .subscribeSelfMedia(params)
        .then((res) => {
          if (res.suc == 1) {
            _this.subscribed = true;
            _this.attentionStr = "已关注";
            _this.addScore('dy'); // 增加积分,订阅
          } else {
            _this.$toast({
              message: res.message,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 取消关注 */
    unSubscribeSelfMedia() {
      var _this = this;
      var params = {
        id: _this.detailInfo.selfChannelId,
        userId: _this.userInfo.id,
        nodeCode: _this.nodeCode,
      };
      mediaApi
        .unSubscribeSelfMedia(params)
        .then((res) => {
          if (res.suc == 1) {
            _this.subscribed = false;
            _this.attentionStr = "+ 关注";
            _this.$toast({
              message: "取消关注成功",
              position: "center",
            });
          } else {
            _this.$toast({
              message: res.message,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 关注/取消关注 */
    onAttentionClick(event) {
      if (!!this.userInfo) {
        /* 已关注则取消关注 */
        if (this.subscribed) {
          this.unSubscribeSelfMedia(); // 取消关注
        } else {
          this.subscribeSelfMedia(); // 关注
        }
      } else {
        this.$router.push("/login");
      }
    },
    /* 点击记者号，跳转记者号详情 */
    toMedia(id) {
      var q = {
        contentType: "we-media",
        id: id,
      }
      if (!!this.headerHidden) {
        q = Object.assign(q, { client: 1 });
      }
      this.$router.push({
        path: "/media_detail",
        query: q,
      });
    },
    /* 获取点赞状态 */
    getThumbsUpStatus() {
      var _this = this;
      var params = {
        contentType: _this.params.contentType,
        contentId: _this.detailInfo.id,
        fromFlag: _this.params.fromFlag,
      };
      if (!!_this.userInfo) {
        params.memberId = _this.userInfo.id;
      } else {
        params.deviceId = _this.deviceId;
      }
      commApi
        .queryThumbsUpStatus(params)
        .then((res) => {
          if (res.suc == 1) {
            _this.topCount = res.data.topCount;
            if (res.data.userLikes == 1) {
              var target1 = _this.$refs.praise1;
              target1.classList.add("praised");
              _this.isLiked = true;
            }else{
              _this.isLiked = false;
              var target1 = _this.$refs.praise1;
              if(target1)
              target1.classList.remove("praised");
            }
          } else {
            _this.$toast({
              message: res.message,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 文章点赞 */
    onPraiseClick(event) {
      var _this = this;
      var target = event.currentTarget;
      let clsArray = target.classList;

      var params = {
        contentType: _this.params.contentType,
        contentId: _this.detailInfo.id,
        fromFlag: _this.params.fromFlag,
      };
      if (!!_this.userInfo) {
        params.memberId = _this.userInfo.id;
      } else {
        params.deviceId = _this.deviceId;
      }

      if (clsArray.contains("praised")) {
        commApi
          .cancelThumbsUp(params)
          .then((res) => {
            if (res.suc == 1) {
              var target1 = _this.$refs.praise1;
              target1.classList.remove("praised");
              _this.isLiked = false;
              _this.topCount--;
              _this.$emit('changeIsPraise')
            } else {
              _this.$toast({
                message: res.message,
                position: "center",
              });
            }
          })
          .catch((err) => {
            _this.$toast({
              message: "接口调用出错",
              position: "center",
            });
          });
      } else {
        let timestamp = Date.now();
        let param=this.genSignatureMd5(timestamp,params);
        console.log('param:------',param);
        commApi
          .giveThumbsUp(params)
          .then((res) => {
            if (res.suc == 1) {
              var target1 = _this.$refs.praise1;
              target1.classList.add("praised");
              _this.isLiked = true;
              _this.topCount++;
              _this.addScore('dz'); // 增加积分,点赞
              _this.$emit('changeIsPraise')
            } else {
              _this.$toast({
                message: res.message,
                position: "center",
              });
            }
          })
          .catch((err) => {
            _this.$toast({
              message: "接口调用出错",
              position: "center",
            });
          });
      }
    },
    genSignatureMd5(sourceKey, params){
      // 1. 参数名按照ASCII码表升序排序  
      const keys = Object.keys(params).sort();  
      let crypto = require("crypto");
      // 2. 按照排序拼接参数名与参数值  
      let sb = '';  
      keys.forEach(key => {  
        const value = params[key];  
        if (value !== null && value !== undefined) {  
            if (typeof value === 'object' && value !== null) {  
                // 假设value是对象或数组，我们递归处理  
                if (Array.isArray(value)) {  
                    // 处理数组，这里假设数组元素也是对象，且需要递归处理  
                    value.forEach(item => {  
                        if (typeof item === 'object' && item !== null) {  
                            sb += this.genSignatureMd5(sourceKey, item);  
                        }  
                    });  
                } else {  
                    sb += this.genSignatureMd5(sourceKey, value);  
                }  
            } else {  
                // 直接拼接key和value  
                sb += `${key}${value}`;  
            }  
        }  
      });  
    
      // 3. 将secretKey拼接到最后  
      sb += sourceKey;  
    
      console.log(`sbStr = ${sb}`);  
    
      // 4. MD5加密  
      return crypto.createHash('md5').update(sb, 'utf8').digest('hex'); 
    },
    toSpecial(data){
      var q = {
        contentType: data.contentType,
        contentId: data.id,
      }
      if(data.specialType===1){
        this.$router.push({
          path: "/special_detail",
          query: q,
        });
      }
      else{
        this.$router.push({
          path: "/column_detail",
          query: q,
        });
      }
      
        
    }
  },
  created() {
    this.detailInfo = deepClone(this.detail);
    if (!!this.detailInfo) {
      this.getThumbsUpStatus();
      if (!!this.userInfo && this.detailInfo.selfChannelOrNot) {
        this.getSubscription(); //获取订阅信息
      }
    }
    let query = this.$route.query;
    if (Object.prototype.hasOwnProperty.call(query, "client")) {
      if (query.client == 1 || query.client == '1' || query.client == true || query.client == 'true') {
        this.headerHidden = true;
      }
    }
  },
  updated() {
    /* 处理正文中的内容内链点击 */
    jq(".content label[data-plugin-type='content']").each(function (i, lab) {
      lab.onclick = function (obj) {
        var id = obj.currentTarget.getAttribute("data-id");
        var originalId = obj.currentTarget.getAttribute("data-original-id");
        var contentType = obj.currentTarget.getAttribute("data-content-type");
        var n = window.location.href.indexOf("#");
        var url = window.location.href.substring(0, n) + "#/index_share?contentType=" + contentType + "&contentId=" + id + "&id=" + originalId;
        window.open(url, "_blank");
      };
    });
    /* 处理正文中的活动内链点击 */
    jq(".content label[data-content-type='1']").each(function (i, lab) {
      lab.onclick = function (obj) {
        var id = obj.currentTarget.getAttribute("data-id");
        var n = window.location.href.indexOf("#");
        var url = window.location.href.substring(0, n) + "#/index_share?contentType=1&activityId=" + id;
        window.open(url, "_blank");
      };
    });
    /* 处理正文中的广告内链点击 */
    jq(".content label[data-content-type='8']").each(function (i, lab) {
      lab.onclick = function (obj) {
        var id = obj.currentTarget.getAttribute("data-id");
        var n = window.location.href.indexOf("#");
        var url = window.location.href.substring(0, n) + "#/index_share?contentType=8&contentId=" + id;
        window.open(url, "_blank");
      };
    });
    /** 强制处理图片、表格、内链 **/
    jq(".content img, .content table").each(function (i, elem) {
      if (elem.getAttribute("data-plugin-type") == "video") {
        return true
      }
      elem.style.maxWidth = "100%";
      elem.style.margin = "0 auto";
      elem.style.height = "auto";
      // elem.style.margin = "0";
    });
    jq("section[data-plugin-type]").css("text-indent", "0");
    jq("section[data-plugin-type]").find("center").css("text-indent", "0");
  },
  mounted(){
    if(this.detailInfo.contentJsCode && this.detailInfo.contentJsCode!=''){
      this.$nextTick(()=>{
        var ele = document.createElement('script');
        ele.innerHTML = this.detailInfo.contentJsCode;
        document.body.append(ele);
      })
    }
  }
};
</script>
<style scoped lang="scss">
.detail_box {
  margin-bottom: 16px;
  /* 标题 */
  .title {
    font-size: 24px;
    line-height: 34px;
    font-weight: bold;
    padding-top: 15px;
    padding-bottom: 0;
    color: #1a1a1a;
  }
  /* 来源，时间，阅读量 */
  .junior {
    height: 42px;
    padding-top: 10px;
    overflow: hidden;
    color: #646464;
    font-size: 12px;
    text-overflow: ellipsis;
    white-space: nowrap;
    span {
      line-height: 32px;
      color: #646464;
      &.source {
        color: #646464;
      }
      &.time {
        margin-left: 10px;
      }
      &.readnum {
        margin-left: 10px;
      }
    }
  }
  /* 记者号：头像、来源，时间，阅读量 */
  .we-media {
    position: relative;
    display: flex;
    height: 54px;
    padding: 8px 0 0 0;
    margin-top: 8px;
    .portrait {
      width: 38.4px;
      height: 38.4px;
      // border: white 1px solid;
      line-height: 38.4px;
      overflow: hidden;
      background-image: url(~@/assets/images/user_default.png);
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      border: 1px solid #fff;
      border-radius: 100%;
      display: flex;
      justify-content: center;
      img {
        object-fit: cover;
        min-width: 100%;
        min-height: 100%;
      }
    }
    .text {
      position: relative;
      width: 100%;
      overflow: hidden;
      flex: 1;
      line-height: 20px;
      padding: 0 6px;
      .nick {
        color: #242424;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 20px;
      }
      .created {
        color: #b8b3ad;
        font-size: 13px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        span {
          font-family: 宋体;
          &.readnum {
            margin-left: 10px;
          }
        }
      }
      .attention {
        position: absolute;
        right: 0;
        top: 10px;
        padding: 0px 8px;
        background: #fff;
        border: 1px solid #b2171b;
        border-radius: 7px;
        color: #b2171b;
        font-size: 12px;
        cursor: pointer;
      }
    }
  }
  /* 内容 */
  .content {
    padding-top: 5px;
    color: #2d2d2d;
    // 针对135编辑器特殊处理
    .block-inner[data-inner-name="135editor-spread"] {
      overflow: hidden;
    }
    /deep/.block-inner[data-inner-name="135editor-spread"] {
      overflow: hidden;
    }
    * {
      max-width: 100%;
      white-space: normal;
      word-break: break-all;
    }
    /deep/p {
      margin: 0;
      padding: 7px 0;
      line-height: 30px;
      font-size: 18px;
      // text-indent: 2em;
      word-break: normal;
      text-align: justify;
      * {
        text-indent: 0 !important;
      }
    }
    /deep/video {
      display: block;
      max-width: 100% !important;
      margin: 0 auto !important;
      padding: 6px 0;
    }
    /deep/img {
      display: block;
      max-width: 100% !important;
      margin: 0 auto !important;
      padding: 6px 0;
    }
  }
  /* 编辑 */
  .editor {
    margin-top: 14px;
    color: #c1c1c1;
    font-size: 14px;
    font-weight: 500;
  }
  /* 更多报道 */
  .moreNews {
    margin-top: 14px;
    color: #1a1a1a;
    font-size: 18px;
    p {
      padding: 0px;
      margin: 0px;
      text-indent: 2em;
      line-height: 29px;
      a {
        color: #ff0000;
        font-weight: bold;
        text-decoration: none;
      }
    }
    .others {
      text-align: justify;
      font-size: 14px;
      color: #b7b2b2;
      .to_copyright {
        text-decoration: none;
        color: #b7b2b2;
        font-weight: bold;
      }
    }
  }
  .line {
    padding-top: 15px;
    width: 100%;
    border-bottom: 1px solid #ececec;
  }
  /* 标签 */
  .tag_list {
    padding-top: 5px;
    li {
      display: inline-block;
      padding-left: 10px;
      padding-right: 10px;
      border: 1px solid #f1f1f1;
      /* box-shadow: 3px 3px 5px #ddd, -1px -1px 6px #ddd; */
      margin-right: 10px;
      margin-top: 10px;
      line-height: 24px;
      color: #777777;
      font-size: 14px;
    }
  }
  /* 点赞 */
  .praise_box {
    position: relative;
    width: 100%;
    padding: 15px 0;
    text-align: center;
    .praise {
      height: 42px;
      width: 154px;
      margin: 8px auto 0;
      line-height: 42px;
      background: #f6f6f6;
      color: #8e8e8e;
      text-align: center;
      font-size: 15px;
      -webkit-border-radius: 21px;
      -moz-border-radius: 21px;
      border-radius: 21px;
      box-shadow: #ddd 0px 4px 7px;
      &.praised {
        background-color: #f8e0e0;
        color: #e60012;
      }
      .van-icon {
        margin-right: 5px;
        font-size: 20px;
        vertical-align: text-bottom;
      }
      .tj-svg-icon {
        margin-right: 5px;
        font-size: 19px;
        vertical-align: -0.1em;
      }
    }
  }
  .media_reporter_box {
    padding-top: 20px;
    /* 记者号 */
    .news_media_list {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 16px;
      padding-bottom: 16px;
      border: 1px solid #f1f1f1;
      .news_media_title {
        position: absolute;
        left: 16px;
        top: -8px;
        z-index: 1;
        padding: 0 12px;
        background: #fff;
        font-size: 12px;
        color: #999;
      }
      ul {
        max-width: 100%;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        position: relative;
        z-index: 1;
        li {
          display: inline-block;
          margin: 5px 10px;
          text-align: center;
          .portrait {
            width: 45px;
            height: 45px;
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
            border-radius: 50%;
            border: 1px solid #bebebe;
          }
          .name {
            margin-top: 10px;
            font-size: 12px;
          }
        }
      }
    }
    .news_media {
      padding-top: 16px;
      /deep/.media_reporter {
        display: flex;
        position: relative;
        padding: 18px 15px;
        background: #fff;
        border: 1px solid #f1f1f1;
        &::after {
          position: absolute;
          top: calc(50% - 0.8em);
          right: 10px;
          z-index: 2;
          width: 25.6px;
          height: 25.6px;
          content: "";
          background: url(~@/assets/images/arrow-right.png) no-repeat right
            center;
          background-size: 25.6px;
        }
        .reporter_portrait {
          position: relative;
          top: 2px;
          width: 64px;
          height: 64px;
          line-height: 64px;
          overflow: hidden;
          background-image: url(~@/assets/images/user_default.png);
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
          border: 2px solid #bebebe;
          border-radius: 100%;
          -webkit-border-radius: 100%;
          -moz-border-radius: 100%;
          display: flex;
          justify-content: center;
          img {
            object-fit: cover;
            min-width: 100%;
            min-height: 100%;
          }
        }
        .reporter_info {
          position: relative;
          width: calc(100% - 64px);
          margin-left: 15px;
          padding-right: 30px;
          .reporter_name {
            line-height: 24px;
            padding-bottom: 5px;
            .name {
              color: #101010;
              font-size: 16px;
              font-weight: bold;
            }
            .sub_num {
              position: relative;
              top: 0;
              float: right;
              font-size: 13px;
            }
          }
          .reporter_intr {
            display: -webkit-box;
            height: 45px;
            overflow: hidden;
            line-height: 22.5px;
            font-size: 13px;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            text-overflow: ellipsis;
            text-align: justify;
            color: #777;
          }
        }
      }
    }
  }
  .related_box {
    margin-bottom: 16px;
    .related_special {
      .labelbar {
        width: 100%;
        line-height: 20px;
        padding: 15px 0 10px;
        color: #df3435;
        text-align: center;
        font-size: 15px;
        font-weight: bold;
        i {
          position: relative;
          top: -5px;
          display: inline-block;
          width: 8px;
          height: 1.5px;
          margin: 0 8px;
          background: #e67c8c;
        }
      }
    }
    .news_list{
      .news_title{
        margin: 0;
        color: rgb(2, 86, 164);
        text-decoration: underline;
      }
    }
  }
}
</style>